import moment from "moment";
import { fromEnv } from "./fromEnv";
import { Merchant } from "src/models";

const businessEntityValidationTime = moment(
  fromEnv("REACT_APP_BUSINESS_ENTITY_VALIDATION_TIMESTAMP")
);

export const skipEntityTypeScreen = (merchant: Merchant): boolean => {
  return (
    !!businessEntityValidationTime &&
    !!merchant.createdAt?.isSameOrAfter(businessEntityValidationTime) &&
    !!merchant.json.business_type
  );
};
